const BADGES = [
  {
    icon: "/images/compliance.svg",
    label: "HIPAA",
    sub: "Compliant",
    type: "icon",
  },
  {
    icon: "/images/iso.svg",
    label: "ISO 27001",
    sub: "Certified",
    type: "icon",
  },
  {
    label: "ABHA",
    sub: "Enabled",
    type: "pill",
  },
];

export default function ComplianceBadges() {
  return (
    <div className="flex w-full flex-wrap md:flex-nowrap items-stretch bg-white border border-slate-200 rounded-xl overflow-hidden">
      {BADGES.map((b, index) => (
        <div
          key={b.label}
          className="w-1/2 md:flex-1 flex items-center justify-center relative"
        >
          {/* Divider (only desktop/tablet horizontal mode) */}
          {index !== 0 && (
            <div className="hidden md:block absolute left-0 top-[15%] bottom-[15%] w-px bg-slate-200" />
          )}

          {/* Badge content */}
          <div className="flex items-center gap-2 px-2 py-2 sm:px-3 sm:py-2 justify-center">
            
            {/* Icon */}
            {b.type === "icon" && (
              <img
                src={b.icon}
                alt={b.label}
                className="w-6 h-6 sm:w-7 sm:h-7 object-contain shrink-0"
              />
            )}

            {/* ABHA pill */}
            {b.type === "pill" && (
              <div className="w-9 h-5 sm:w-10 sm:h-6 bg-[#1a7a4a] rounded-md flex items-center justify-center shrink-0">
                <span className="text-[0.55rem] sm:text-[0.6rem] font-bold text-white tracking-wide">
                  ABHA
                </span>
              </div>
            )}

            {/* Text */}
            <div className="flex flex-col">
              <span className="ava-text-body">
                {b.label}
              </span>
              <span className="ava-text-caption">
                {b.sub}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// export default function ComplianceBadges() {
//   return (
//     <div className="flex w-full items-stretch bg-white border border-slate-200 rounded-xl overflow-hidden">
//       {BADGES.map((b, index) => (
//         <div
//           key={b.label}
//           className="flex-1 flex items-center justify-center relative"
//         >
//           {/* Divider */}
//           {index !== 0 && (
//             <div className="absolute left-0 top-[15%] bottom-[15%] w-px bg-slate-200" />
//           )}

//           {/* Badge content */}
//           <div className="flex items-center gap-2.5 px-3 py-2.5 justify-center">
//             {/* Icon type */}
//             {b.type === "icon" && (
//               <img
//                 src={b.icon}
//                 alt={b.label}
//                 width={28}
//                 height={28}
//                 className="w-7 h-7 object-contain shrink-0"
//               />
//             )}

//             {/* Pill type */}
//             {b.type === "pill" && (
//               <div className="w-10 h-6 bg-[#1a7a4a] rounded-md flex items-center justify-center shrink-0">
//                 <span className="text-[0.6rem] font-bold text-white tracking-wide">
//                   ABHA
//                 </span>
//               </div>
//             )}

//             {/* Text */}
//             <div className="flex flex-col gap-0">
//               <span className="text-[0.78rem] font-bold text-gray-900 leading-tight">
//                 {b.label}
//               </span>
//               <span className="text-[0.68rem] text-gray-500 leading-tight">
//                 {b.sub}
//               </span>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }







// import styles from "./ComplianceBadges.module.css";

// const BADGES = [
//   {
//     icon: "/images/compliance.svg",
//     label: "HIPAA",
//     sub: "Compliant",
//     type: "icon",
//   },
//   {
//     icon: "/images/iso.svg",
//     label: "ISO 27001",
//     sub: "Certified",
//     type: "icon",
//   },
//   {
//     label: "ABHA",
//     sub: "Enabled",
//     type: "pill",
//   },
// ];

// export default function ComplianceBadges() {
//   return (
//     <div className={styles.card}>
//       {BADGES.map((b, index) => (
//         <div key={b.label} className={styles.badgeWrapper}>
//             {index !== 0 && <div className={styles.divider} />}

//           <div className={styles.badge}>
//             {b.type === "icon" && (
//               <img
//                 src={b.icon}
//                 alt={b.label}
//                 width={36}
//                 height={36}
//                 className={styles.iconImg}
//               />
//             )}

//             {b.type === "pill" && (
//               <div className={styles.abhaPill}>
//                 <span className={styles.abhaText}>ABHA</span>
//               </div>
//             )}

//             <div className={styles.textWrap}>
//               <span className={styles.label}>{b.label}</span>
//               <span className={styles.sub}>{b.sub}</span>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }
